// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__DJu3d","icon":"SortAdornment_icon__2H_ji","up":"SortAdornment_up__B8hBh","down":"SortAdornment_down__2FMVc","active":"SortAdornment_active__OrsuG"};